import React, { useState, useEffect } from "react";
import { Wrapper } from "./CustomerDetails.styled";


import LeadDetails from "views/LeadDetails/LeadDetails";

const CustomerDetails = () => {
  return (
   <Wrapper>
     <LeadDetails/>
    </Wrapper>
  );
};

export default CustomerDetails;
